/**
 * AllAll Wan 2.5：POST /v1/video/generations（JSON），GET /v1/video/generations/{id} 轮询
 * 参数：model=wan2.5-i2v-preview, prompt, input_reference(URL或Base64), size, duration, metadata
 */
var SIZE_MAP = { '480p': '480P', '480P': '480P', '720p': '720P', '720P': '720P', '1080p': '1080P', '1080P': '1080P' }

function normalizeSize(v) {
  if (!v) return '720P'
  var key = String(v).trim()
  return SIZE_MAP[key] || '720P'
}

function normalizeDuration(n) {
  var num = parseInt(n, 10)
  if (isNaN(num)) return 5
  if (num < 3) return 3
  if (num > 10) return 10
  return num
}

/** 从 data URL 提取 base64，否则原样返回（URL 或已是 base64） */
function toInputReference(val) {
  if (!val || typeof val !== 'string') return ''
  var s = val.trim()
  if (s.indexOf('data:') === 0) {
    var i = s.indexOf('base64,')
    return i >= 0 ? s.slice(i + 7) : s
  }
  return s
}

/**
 * 构建 AllAll Wan 2.5 POST /v1/video/generations 的 JSON body
 * @param {Object} params - prompt, referenceImage(URL或Base64字符串), videoDuration?, videoRes?, negativePrompt?, generateAudio?, seed?, etc.
 */
export function buildBody(params) {
  var inputRef = toInputReference(params.referenceImage)
  if (!inputRef) throw new Error('AllAll Wan 2.5 图生视频需要首帧图像（URL 或 Base64）')
  var body = {
    model: 'wan2.5-i2v-preview',
    prompt: (params.prompt || '').trim().slice(0, 2000),
    input_reference: inputRef,
    size: normalizeSize(params.videoRes || params.resolution),
    duration: normalizeDuration(params.videoDuration || params.length || 5)
  }
  var meta = {}
  if (params.negativePrompt && String(params.negativePrompt).trim()) {
    meta.negative_prompt = String(params.negativePrompt).trim().slice(0, 500)
  }
  if (params.audioUrl && typeof params.audioUrl === 'string' && params.audioUrl.trim()) {
    meta.audio_url = params.audioUrl.trim()
  }
  meta.prompt_extend = params.promptExtend !== false
  meta.watermark = params.watermark === true
  meta.audio = params.generateAudio !== false
  if (params.seed != null && params.seed !== '' && params.seed !== -1) {
    var seed = parseInt(params.seed, 10)
    if (!isNaN(seed) && seed <= 2147483647) meta.seed = seed
  }
  body.metadata = meta
  return body
}

/**
 * 解析 AllAll GET /v1/video/generations/{id} 的响应
 * res 为响应 body：{ code, data: { task_id, status, fail_reason, data: { output: { video_url } } } }
 */
export function parsePollResponse(res) {
  var payload = res && res.data
  if (!payload) return { status: 'waiting' }
  var status = payload.status
  if (status === 'SUCCESS') {
    var url = payload.data && payload.data.output && payload.data.output.video_url
    return { status: 'completed', url: url }
  }
  if (status === 'FAILED' || status === 'CANCELED') {
    return { status: 'failed', error: (payload.fail_reason && String(payload.fail_reason)) || '生成失败' }
  }
  return { status: 'waiting' }
}
